/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UserLeaderboardQueryVariables = {||};
export type UserLeaderboardQueryResponse = {|
  +userLeaderboard: ?any
|};
export type UserLeaderboardQuery = {|
  variables: UserLeaderboardQueryVariables,
  response: UserLeaderboardQueryResponse,
|};
*/


/*
query UserLeaderboardQuery {
  userLeaderboard
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userLeaderboard",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserLeaderboardQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserLeaderboardQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "bd240211cc579706d58db6fdfb7d96fa",
    "id": null,
    "metadata": {},
    "name": "UserLeaderboardQuery",
    "operationKind": "query",
    "text": "query UserLeaderboardQuery {\n  userLeaderboard\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '97115053ba87346e991a77e1669ede9c';

module.exports = node;
